import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NewVersionService } from './new-version.service';

@Component({
  selector: 'app-new-version-banner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (service.newVersionAvailable()) {
    <div class="new-version-banner" data-testid="new-version-banner" role="alert">
      <span class="new-version-banner__text">A new version is available. Reload to continue.</span>
      <button type="button" class="new-version-banner__action" (click)="service.reload()">
        Reload
      </button>
    </div>
    }
  `,
  styles: [
    `
      .new-version-banner {
        position: sticky;
        top: 0;
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        flex-wrap: wrap;
        padding: 0.5rem 1rem;
        background: #f59e0b;
        color: #1f2937;
        font-size: 0.875rem;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      }
      .new-version-banner__action {
        background: #1f2937;
        color: #fff;
        border: 0;
        padding: 0.25rem 0.75rem;
        border-radius: 0.25rem;
        cursor: pointer;
        font-weight: 600;
      }
      .new-version-banner__action:hover {
        background: #111827;
      }
    `,
  ],
})
export class NewVersionBannerComponent {
  protected readonly service = inject(NewVersionService);
}
